


















import { Component, Watch, Vue } from 'vue-property-decorator';
import { billService } from '@/services/BillService';
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import Detail from '@/components/bill/detail/Detail.vue';
import ShipmentList from '@/components/bill/detail/ShipmentList.vue';
import Preview from '@/components/bill/detail/Preview.vue';
import Callout from '@/components/Callout.vue';
import Publish from '@/components/bill/detail/Publish.vue';
import NavBar from '@/components/layout/NavBar.vue';
import {
  BillUpdate,
  fetchBill_bills
} from '@/types/graphql/schemaTypes';
import omit from 'lodash/omit';

@Component({
  components: {
    NavBar,
    'bill-detail': Detail,
    'bill-shipment-list': ShipmentList,
    'bill-preview': Preview,
    'delete-callout': Callout,
    'bill-publish': Publish
  }
})
export default class Details extends Vue {
  private bill: fetchBill_bills | null = null;

  private created(): void {
    this.fetchBill();
  }

  public fetchBill(): void {
    billService.fetchBill(this.$route.params.id)
      .then((result) => {
        this.bill = result.data.bills[0];
      });
  }

  private toggleDeleteModal() {
    this.$store.dispatch('App/openConfirmationModal', {
      mutation: 'Bill/setBillToDelete',
      payload: { id: this.bill!.id }
    });
  }

  @Watch('$store.state.Bill.updateBillAttrs')
  private updateBill(storedValue: any): void {
    const updateBillCallback = (results: FetchResult<BillUpdate>): void => {
      this.fetchBill();
    };

    if (storedValue.id) {
      billService.updateBill(
        {
          ...omit(storedValue, ['shipper', 'shipments', 'customerOrganization', 'billItems']),
          id: storedValue.id
        }
      )
        .then(updateBillCallback);
    }
  }

  @Watch('$store.state.Bill.billToDelete')
  private deleteBill(payload: any) {
    if (!payload.id) { return; }
    billService.deleteBill({ id: payload.id }).then(() => {
      this.$router.push({ name: 'bills' });
    });
  }

  @Watch('$store.state.Bill.billToPublish')
  private publishBill(payload: { id: string }) {
    billService.publishBill(payload).then(() => {
      this.fetchBill();
      this.$store.dispatch('Alert/addAlert', {
        type: 'success',
        message: this.$t('bill.sent.success')
      });
    });
  }
}
